import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Calendar, EventApi, EventInput } from '@fullcalendar/core';
import { ResourceSourceInput } from '@fullcalendar/resource';

@Injectable({ providedIn: 'root' })
export class CalendarEventsService {
  // Control modal visibility and selected data
  public addCalendarEventModalSub = new Subject<boolean>();
  public addCalendarEventModalData: {
    start?: Date;
    end?: Date;
    event?: EventApi;
    patients?: ResourceSourceInput;
    personnel?: ResourceSourceInput;
    departments?: ResourceSourceInput;
    recurrentType?: any;
    appointmentServiceTypeList?: any[];
    appointmentReasonList?: any[];
    resourceId?: string;
    carePlanPeriodEnd?: string | Date | null;
    onCreateSuccess?: ((appointmentId: number, eventData?: EventInput) => void) | null;
    onUpdateSuccess?: ((appointmentId: number, eventData?: EventInput) => void) | null;
  } = {};

  // Control view event modal visibility and selected data.
  public viewCalendarEventModalSub = new Subject<boolean>();
  public viewCalendarEventModalData: {
    event?: EventApi;
    patients?: any[];
    personnel?: any[];
    departments?: any[];
    recurrentType?: number;
    appointmentStatusList?: any[];
    appointmentServiceTypeList?: any[];
    appointmentReasonList?: any[];
    slotStatusList?: any[];
    participantStatusList?: any[];
    isReadOnly?: boolean;
  } = {};

  // Calendar visibility as BehaviorSubject
  private calendarVisibleSubject = new BehaviorSubject<boolean>(true);
  calendarVisible$ = this.calendarVisibleSubject.asObservable();

  // Emitters for add/edit event
  private addEventSubject = new BehaviorSubject<any>(null);
  private editEventSubject = new BehaviorSubject<any>(null);
  private updateEventSubject = new Subject<{
    event: any;
    updateType?: number;
  } | null>();
  private deleteEventSubject = new BehaviorSubject<any>(null);

  addEvent$ = this.addEventSubject.asObservable();
  editEvent$ = this.editEventSubject.asObservable();
  updateEvent$ = this.updateEventSubject.asObservable();
  deleteEvent$ = this.deleteEventSubject.asObservable();

  // Set calendar visibility
  setCalendarVisible(value: boolean) {
    this.calendarVisibleSubject.next(value);
  }

  toggleCalendarVisible() {
    this.calendarVisibleSubject.next(!this.calendarVisibleSubject.value);
  }

  // Emit events
  addEvent(event: any) {
    this.addEventSubject.next(event);
  }

  editEvent(event: any) {
    this.editEventSubject.next(event);
  }

  updateEvent(event: any, updateType?: number) {
    this.updateEventSubject.next({ event, updateType });
  }

  deleteEvent(event: any) {
    this.deleteEventSubject.next(event);
  }
}
